/**
 * 经典金主题 — 颜色与设计令牌
 * 逻辑字段不变，仅用于样式定制
 */
export default {
  // 主色
  primary: '#DC811D',
  primaryLight: '#E68608',
  primaryDark: '#CC8F4E',
  primaryHighlight: '#FFAF00',

  // 按钮
  btnText: '#996A30',
  btnTextAlt: '#895C25',
  btnGradientStart: '#ECD2A1',
  btnGradientEnd: '#D4B077',
  btnStrongGradientStart: '#F6D07F',
  btnStrongGradientEnd: '#D78D2A',
  btnStrongGradientEnd2: '#D47000',

  // 边框
  borderGold: '#DBA95A',
  borderAccent: '#E68608',
  borderGray: '#AAAAAA',
  borderLight: '#CCCCCC',
  borderLighter: '#DDDDDD',

  // 文字
  textPrimary: '#333333',
  textSecondary: '#555555',
  textMuted: '#888888',
  textDisabled: '#999999',
  textBrownDark: '#524535',
  textBrown: '#7F7870',
  textBrownLight: '#776A5A',
  textBrownMuted: '#736B5A',
  textTitle: '#404141',
  textPlaceholder: '#BBBBBB',
  textGray: '#777777',
  textDark: '#000000',

  // 状态色
  success: '#029B00',
  danger: '#DA5B5B',
  dangerBg: 'rgba(218, 91, 91, 0.1)',
  tipsRed: '#FF2828',
  amountRed: '#F03024',
  errorRed: '#E72E2E',

  // 背景
  bgPage: '#F5F5F5',
  bgCard: '#FFFFFF',
  bgSecondary: '#F2F2F2',
  bgInput: '#F5F5F5',
  bgStripe: '#F1F1F1',
  bgOverlay: 'rgba(122, 122, 122, 0.1)',
  bgBadge: 'rgba(51, 51, 51, 0.12)',

  // 头部区域
  headerText: '#FFFFFF',
  headerSubText: '#E5E5E5',
  headerMutedText: '#EEEEEE',

  // 其他
  white: '#FFFFFF',
  disabled: '#99A1AB',
  smsBtn: '#6E86A1',
  pendingDesc: '#948F8A',
  copyBtn: '#B6B6B6',
  tipsColor: '#DA5B5B',
};
